// extracted by mini-css-extract-plugin
export var callCard = "_oo-0";
export var callMessageButton = "_oo-1";
export var helpIcon = "_oo-3";
export var helpIconContainer = "_oo-4";
export var verticalDivider = "_oo-2";